import { DateTimeType } from './dateTypes';
import { z } from 'zod';

export const Substitute = z.object({
    id: z.string(),
    userId: z.string(),
    from: DateTimeType.nullish(),
    to: DateTimeType.nullish(),
});
export type Substitute = z.infer<typeof Substitute>;
